export default "__VITE_ASSET__a56e1bc6__"